<template>
  <nav class="gradient-background text-white flex items-center justify-end md:justify-start">
    <a class="skip-to-main-content" href="#main-content">
      {{ $t("Common.SkipToContent") }}
    </a>

    <InstitutionSelector
      v-if="isInstitutionSelectorVisible"
      class="ml-auto md:ml-0 md:mr-auto"
      @institutionIsGoingToChange="onInstitutionIsGoingToChange"
      @institutionChanged="onInstitutionChanged"
    />

    <UserInfo v-if="isUserInfoVisible" class="ml-auto" />

    <div class="loader-line opacity-animation opacity-0" :class="{ 'opacity-100': globalsStore.loaderStatus }"></div>
  </nav>
</template>

<script>
import { useGlobalsStore } from "@/stores/globals";
import UserInfo from "@/components/Navigation/UserInfo.vue";
import { useMeStore } from "@/stores/me";

export default {
  name: "TopPanel",

  props: {
    isInstitutionSelectorVisible: {
      type: Boolean,
      default: true
    },

    isUserInfoVisible: {
      type: Boolean,
      default: true
    }
  },

  setup() {
    return {
      globalsStore: useGlobalsStore(),
      meStore: useMeStore()
    };
  },

  methods: {
    onInstitutionIsGoingToChange() {
      this.$emit("institutionIsGoingToChange");
    },

    onInstitutionChanged() {
      this.$emit("institutionChanged");
    }
  },

  components: {
    InstitutionSelector: () => import("@/components/Navigation/InstitutionSelector"),
    UserInfo
  }
};
</script>

<style scoped>
.gradient-background {
  background: var(--color-primary-core);
  background: linear-gradient(176deg, var(--color-primary-core) 51%, var(--color-primary-light) 100%);
}

.loader-line {
  width: 100%;
  height: 5px;
  background: linear-gradient(to right, var(--color-primary-core), #f5f5f5, var(--color-primary-light));
  background-color: transparent;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 5px;
  background-size: 10%;
  background-repeat: repeat-y;
  background-position: -25% 0;
  animation: scroll 2.2s ease-in-out infinite;
}

@keyframes scroll {
  50% {
    background-size: 100%;
  }
  100% {
    background-position: 125% 0;
  }
}

.opacity-animation {
  transition: opacity 0.5s ease-in-out infinite;
}

.skip-to-main-content {
  @apply p-2 absolute bg-white text-sm rounded-b-md text-core-text top-0;
  left: 50%;
  transform: translateY(-100%);
}

.skip-to-main-content:focus {
  @apply underline;
  transform: translateY(0);
}
</style>
